import _ from 'underscore';

export default class OfferCampaignRecipientsDialog {
  constructor($scope, $rootScope, $q, OfferCampaignService) {
    $scope.$on('show_recipients_dialog', function(event, data) {
      window.openFancyboxDialog('div#offer_campaign_recipients_dialog');
      $scope.offer_campaign_id = data.offer_campaign_id;
      add_recipients(data.general_buyers, data.special_buyers, data.min_quantity);
    });

    $scope.steps = [
      {
        id: 1,
        title: 'Add Selected Recipients'
      },
      {
        id: 2,
        title: 'Create XLS for General Recipients'
      },
      {
        id: 3,
        title: 'Calculate Qty for Special Recipients'
      },
      {
        id: 4,
        title: 'Embed matched for Special Recipients'
      },
      {
        id: 5,
        title: 'Create XLS for Special Recipients'
      },
      {
        id: 6,
        title: 'Ignore PI XLS for Special Recipients'
      },
      {
        id: 7,
        title: 'Mark template done for Special Recipients'
      }
    ];

    function set_processing(step_index) {
      if (step_index > 0) {
        $scope.steps[step_index - 1].processing = false;
        $scope.steps[step_index - 1].completed = true;
      }
      $scope.steps[step_index].processing = true;
    }

    function create_general_xls(recipients) {
      $scope.steps[1].progress = 0;
      $scope.steps[1].progress_started = true;
      return recipients.reduce(function(promise, recipient, index) {
        return promise.then(function() {
          $scope.steps[1].progress = Math.ceil((index / recipients.length) * 100);
          return OfferCampaignService.create_general_xls($scope.offer_campaign_id, recipient.user_id, recipient.attachments.delivery_country_id);
        });
      }, $q.when(true));
    }

    function calculate_special_qty(recipients) {
      $scope.steps[2].progress = 0;
      $scope.steps[2].progress_started = true;
      return recipients.reduce(function(promise, recipient, index) {
        return promise.then(function(response) {
          if (response && response.data)
            recipients[index - 1].matched_quantity = response.data.matched_quantity;
          $scope.steps[2].progress = Math.ceil((index / recipients.length) * 100);
          return OfferCampaignService.get_matched_quantity($scope.offer_campaign_id, recipient.user_id, recipient.attachments.delivery_country_id);
        });
      }, $q.when(true));
    }

    function embed_matched_special(recipients, min_quantity) {
      $scope.steps[3].progress = 0;
      $scope.steps[3].progress_started = true;
      return recipients.reduce(function(promise, recipient, index) {
        return promise.then(function(response) {
          update_recipient_with_text(index - 1, response);
          $scope.steps[3].progress = Math.ceil((index / recipients.length) * 100);
          if (min_quantity > 0 && recipient.matched_quantity > min_quantity)
            return OfferCampaignService.update_recipient_embed_matched(recipient.id, true);
          else
            return true;
        });
      }, $q.when(true));
    }

    function create_special_xls(recipients) {
      $scope.steps[4].progress = 0;
      $scope.steps[4].progress_started = true;
      return recipients.reduce(function(promise, recipient, index) {
        return promise.then(function() {
          $scope.steps[4].progress = Math.ceil((index / recipients.length) * 100);
          return OfferCampaignService.create_special_xls($scope.offer_campaign_id, recipient.user_id, recipient.attachments.delivery_country_id, true, false);
        });
      }, $q.when(true));
    }

    function ignore_pi_xls(recipients) {
      $scope.steps[5].progress = 0;
      $scope.steps[5].progress_started = true;
      return recipients.reduce(function(promise, recipient, index) {
        return promise.then(function(response) {
          update_recipient_with_text(index - 1, response);
          $scope.steps[5].progress = Math.ceil((index / recipients.length) * 100);
          if (recipient.user_data.is_pi)
            return OfferCampaignService.set_recipient_attachment(recipient.id, [{
              key: 'ignore_pi_xls',
              value: true
            }, {
              key: 'stocklist_pi_xls',
              value: false
            }]);
          else
            return true;
        });
      }, $q.when(true));
    }

    function mark_template_done(recipients) {
      $scope.steps[6].progress = 0;
      $scope.steps[6].progress_started = true;
      return recipients.reduce(function(promise, recipient, index) {
        return promise.then(function() {
          $scope.steps[6].progress = Math.ceil((index / recipients.length) * 100);
          return OfferCampaignService.update_recipient_template_text(recipient.id, recipient.template_text, recipient.template_text_per, true);
        });
      }, $q.when(true));
    }

    function filter_recipients(buyers, all_recipients) {
      var recipients = [];
      _.each(_.pluck(buyers, 'id'), function(buyer_id) {
        var recipient = _.findWhere(all_recipients, {
          user_id: buyer_id
        });
        recipients.push(recipient);
      });
      return recipients;
    }

    function update_recipient_with_text(index, response) {
      if (response.data && response.data.template_text)
        $scope.special_recipients[index].template_text = response.data.template_text;
      if (response.data && response.data.template_text_per)
        $scope.special_recipients[index].template_text_per = response.data.template_text_per;
    }

    function add_recipients(general_buyers, special_buyers, min_quantity) {
      set_processing(0);
      OfferCampaignService.add_recipients($scope.offer_campaign_id, general_buyers, special_buyers)
        .then(function(/*response*/) {
          set_processing(1);
          return OfferCampaignService.get_recipients($scope.offer_campaign_id, 0, 1);
        })
        .then(function(response) {
          var recipients = filter_recipients(general_buyers, response.data.recipients);
          return create_general_xls(recipients);
        })
        .then(function() {
          $scope.steps[1].progress = 100;
          set_processing(2);
          return OfferCampaignService.get_recipients($scope.offer_campaign_id, 1, 1);
        })
        .then(function(response) {
          $scope.special_recipients = filter_recipients(special_buyers, response.data.recipients);
          return calculate_special_qty($scope.special_recipients);
        })
        .then(function(response) {
          if (response && response.data)
            $scope.special_recipients[$scope.special_recipients.length - 1].matched_quantity = response.data.matched_quantity;

          $scope.steps[2].progress = 100;
          set_processing(3);
          return embed_matched_special($scope.special_recipients, min_quantity);
        })
        .then(function(response) {
          update_recipient_with_text($scope.special_recipients.length - 1, response);
          $scope.steps[3].progress = 100;
          set_processing(4);
          return create_special_xls($scope.special_recipients);
        })
        .then(function() {
          $scope.steps[4].progress = 100;
          set_processing(5);
          return ignore_pi_xls($scope.special_recipients);
        })
        .then(function(response) {
          update_recipient_with_text($scope.special_recipients.length - 1, response);
          $scope.steps[5].progress = 100;
          set_processing(6);
          return mark_template_done($scope.special_recipients);
        })
        .then(function() {
          $scope.steps[6].progress = 100;
          var data = {
            general_buyers: general_buyers,
            special_buyers: special_buyers
          };
          $rootScope.$broadcast('remove_automated_recipients', data);
        });
    }
  }
}

OfferCampaignRecipientsDialog.$inject = ['$scope', '$rootScope', '$q', 'OfferCampaignService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-campaign-recipients-dialog.ctrl.js